import React, { Component } from 'react'
import { getChamp } from '../../utils/champsFunctions';

/* Components */
import ConfrontationSwitchingAndRotationView from './ConfrontationSwitchingAndRotationView';

class ConfrontationSwitchingAndRotation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,
        }
    }

    componentWillMount = async () => {
        let arrayOfRoute = this.props.location.pathname.split('/')

        // Get specific champ object
        const champId = arrayOfRoute[3];
        const champ = await getChamp(champId);
        this.setState({
            champObject: champ,
            champId
        });
    }

    render() {
        return (
            <ConfrontationSwitchingAndRotationView
                champObject={this.state.champObject}
                champId={this.state.champId}
            />
        )
    }
}

export default ConfrontationSwitchingAndRotation